import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 模块
/*const userModule = {
    namespaced: true,
    state: {
        userInfo: {
            id: 0,
            uid: 'admin',
            mobile: '',
            email: '',
            lastLogin: ''
        },
        userTestNumber: 0
    },
    mutations: {
        setUser (state, payload) {
            console.log('设置用户信息：')
            console.log(payload)
            // 这里的 `state` 对象是模块的局部状态
            state.userInfo = payload
        },
        setUserTestNumber (state) {
            // 这里的 `state` 对象是模块的局部状态
            state.userTestNumber++
        }
        /!*
         store.commit('increment', {
          amount: 10
        })
        store.commit({
          type: 'increment',
          amount: 10
        })
        * *!/
    },
    actions: {
        // store.dispatch('setUser') 触发
        setUser (context,payload) {
            context.commit('setUser',payload)
        },
        // 同样，对于模块内部的 action，局部状态通过 context.state 暴露出来，根节点状态则为 context.rootState：
        setUserTestNumber ({ state, commit, rootState }) {
            /!* if ((state.count + rootState.count) % 2 === 1) {
                commit('increment')
            } *!/
            commit('setUserTestNumber')
        }
        /!*
        解构简写：
            increment ({ commit }) {
                commit('increment')
              }
        调用：
        // 以载荷形式分发
            store.dispatch('incrementAsync', {
              amount: 10
            })

            // 以对象形式分发
            store.dispatch({
              type: 'incrementAsync',
              amount: 10
            })
        * *!/

    },
    getters: {
        // getters相当于计算属性
        userTestNumber (state) {
            return state.userTestNumber * 2
        }
        // 对于模块内部的 getter，根节点状态会作为第三个参数暴露出来：
        /!* sumWithRootCount (state, getters, rootState) {
            return state.count + rootState.count
        } *!/

    }
}

const systemModule = {
    state: {},
    mutations: {},
    actions: {}
}*/
// 模块 END
/*
store.state.user // -> userModule 的状态
store.state.system // -> systemModule 的状态
*/
export default new Vuex.Store({
    /* modules:{
         user: userModule,
         system: systemModule
     }, */
    state: {
        user: {
            id: 0,
            uid: '',
            mobile: '',
            email: '',
            lastLogin: ''
        },
        admin: {
            id: 0,
            uid: '',
            mobile: '',
            email: '',
            lastLogin: ''
        },
        sysPagerHeader: {
            title: '',
            desc: '',
            breadcrumb: [] // 面包屑导航
        },
        shoppingCart: {
            count: 0
        },
        searchTools: {
            keywords: ''
        }
    },
    mutations: {
        setUser (state, payload) {
            console.log('设置用户信息：')
            console.log(payload)
            // 这里的 `state` 对象是模块的局部状态
            state.user = payload
        },
        setAdmin (state, payload) {
            console.log('设置管理员信息：')
            console.log(payload)
            // 这里的 `state` 对象是模块的局部状态
            state.admin = payload
        },
        userLogout (state) {
            state.user = {
                id: 0,
                uid: '',
                mobile: '',
                email: '',
                lastLogin: ''
            }
        },
        setSysPagerHeader (state, payload) {
            // console.log(payload)
            state.sysPagerHeader = payload
        },
        setShoppingCartCount (state, payload) {
            console.log('添加购物车数量：')
            console.log(state)
            state.shoppingCart = payload
        },
        searchTools (state, payload) {
            state.searchTools = payload
        }
    },
    actions: {
        // this.$store.dispatch('setUser',{}) 触发
        setUser (context,payload) {
            context.commit('setUser',payload)
        },
        setAdmin (context,payload) {
            context.commit('setAdmin',payload)
        },
        userLogout (context) {
            context.commit('userLogout')
        },
        setShoppingCartCount (context, payload) {
            context.commit('setShoppingCartCount', payload)
        },
        searchTools (context, payload) {
            context.commit('searchTools', payload)
        }
    }
})

/*
commit 用于调用mutation，当前模块和其他模块；
dispatch 用于调用action，当前模块和其他模块；
getters 用于获取当前模块getter；
state 用于获取当前模块state；
rootState 用于获取其它模块state；
rootGetters 用于获取其他模块getter；

* */
